export const RISK_AMOUNT_OPTIONS = [1000, 1250, 1500, 1750, 2000];
export const DEFAULT_RISK_AMOUNT = RISK_AMOUNT_OPTIONS[0];

// The stop sits at 2x the 21-day ATR so normal volatility doesn't shake us out.
export const STOP_ATR_MULTIPLIER = 2;

export const calculateRiskPosition = (riskAmount, atrPercent) => {
  const atr = Number.parseFloat(atrPercent);
  if (!Number.isFinite(atr) || atr <= 0 || !(riskAmount > 0)) {
    return null;
  }
  const stopDistancePercent = atr * STOP_ATR_MULTIPLIER;
  if (stopDistancePercent >= 100) {
    return null;
  }
  return {
    stopDistancePercent,
    positionSize: riskAmount / (stopDistancePercent / 100)
  };
};

export const calculateBuyQuantity = (targetSize, price, availableCash) => {
  const idealQuantity = Math.floor(targetSize / price);
  const maxQuantity = Math.floor(availableCash / price);
  return Math.min(idealQuantity, maxQuantity);
};
